<header class="wrapper bg-light">
    <div class="navbar-container">
        <nav class="navbar navbar-expand-lg classic transparent navbar-light">
            <div class="container flex-lg-row flex-nowrap align-items-center">
                <div class="navbar-brand w-100">
                    <!-- <a href="./index.html">
                    <img class="logo-dark" src="./assets/img/logo.png" alt="Autoverse Logo" />
                    </a> -->
                    <div style="display: flex; align-items: center !important; text-align: center !important; gap: 2%;">
                        <img style="width: 30px;" class="logo-dark" src="./assets/img/mobile_autoverse_logo.svg" alt="Autoverse Logo" />
                        <h2 style="font-size: 20px; margin: 0;">AUTOVERSE</h2>
                    </div>
                </div>
                <div class="navbar-collapse offcanvas offcanvas-nav offcanvas-start">
                    <div class="offcanvas-header d-lg-none">
                    <h3 class="text-white fs-30 mb-0">Autoverse</h3>
                    <button type="button" class="btn-close btn-close-white" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                    </div>
                    <div class="offcanvas-body ms-lg-auto d-flex flex-column h-100">
                    <ul class="navbar-nav">
                        <!-- <li class="nav-item">
                        <a class="nav-link " href="./index.html">Home</a>
                        </li> -->
                        <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle active" href="#" id="aboutUsDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">Why Autoverse</a>
                        <ul class="dropdown-menu" aria-labelledby="aboutUsDropdown">
                            <li><a class="dropdown-item" href="#expand-your-reach">Expand Your Reach</a></li>
                            <li><a class="dropdown-item" href="#unlock-full-potential">Unlock Full Potential</a></li>
                            <li><a class="dropdown-item" href="#garage-partner-benefits">Garage and Partner Benefits</a></li>
                            <li><a class="dropdown-item" href="#unmatched-benefits">Unmatched Benefits</a></li>
                        </ul>
                        </li>
                        <li class="nav-item"> <a class="nav-link scroll" href="#key-offerings">Key Offerings</a> </li>  
                        <li class="nav-item d-none" id="scroll-cta" style="padding: 15px 0;">
                            <a class="btn btn-primary rounded-pill px-4 ms-lg-3"
                            href="#"
                            data-bs-toggle="modal"
                            data-bs-target="#modal-join-us">
                            Join Us
                            </a>
                        </li>
            
                        </ul>
                    </div>
                </div>
            </div>
        </nav>
    </div>
</header>